import { Box, Button, Card, CardContent, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@material-ui/core"
import { DateRange, Store } from "@material-ui/icons";
import { backgroundImage1 } from "../../components/invoice-generator/backgrounImage";
import { getOrderColorStatues, getOrderStatusLabel } from "../balanceCustRPT-services";
import { useTranslation } from "react-i18next";

const OrderCard = ({order}) =>{
    const {t} = useTranslation(["forms"]);
    const isSmallScreen = useMediaQuery("(max-width:768px");
    const products = order.products;
    // const products = [{product_name:"jsdflksd", id:1, order_quantity:3, unit_price:300}]

    console.log("the productss ", products?.length)
    return(
        <Card
        // display="flex"
        
        sx={{
            width:"100%",
            maxWidth: isSmallScreen? "100%": 1000,
            boxShadow:3,
            borderRadius:3
        }}>
            <CardContent >
                <Box display="flex" justifyContent="space-between">
                    <Box>

                    <Typography variant="h6" fontWeight="bold" style={{ direction: "rtl" }}>
                        order # {order?.id}                        
                    </Typography>
                    <Box display={"flex"} alignItems={"space-between"} gap={2} mt={1}>
                    <DateRange color="action" style={{marginInline:5}}/>
                    {"   "}
                    <Typography variant="body1" fontWeight="textSecondary">
                        
                          {order?.created_at}
                    </Typography>
                    </Box>
                    </Box>
                    <Chip
                    size="large"
                  // className={classes.chip}
                        label={getOrderStatusLabel(order.status)}
                        // variant="outlined"
                        //   color={getOrderColorStatues(0)}
                        style={{
                        backgroundColor:  getOrderColorStatues(order.status) ,
                        color: "#fff",
                        fontWeight:'bold',
                        fontSize:'16px'
                        }}
                        // clickable
                    />
                    
                </Box>
                {/*<Box display={"flex"} alignItems={"space-between"} gap={1} mt={1}>
                 <Box display={"flex"} alignItems={"space-between"} gap={1} mt={1}>
                    <Store color="action" />
                    <Typography variant="body1">sotre: </Typography>
                    <Chip label="orax soft" color="info" size="small" />
                    </Box>
                </Box> */}
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Typography variant="body1" mt={1}>
                        <strong>{t('pay-type')}:</strong> agel
                    </Typography>
                    <Typography variant="body1" mt={1}>
                        <strong>{t('invoice-id')}:{" "}</strong>{order?.invoice_id}
                        
                        {/* <Button variant="outlined" size="small" >
                            search
                        </Button> */}
                    </Typography>
                </Box>
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Typography variant="body1" mt={1}>
                        <strong>{t('الحالة')}:</strong> {getOrderStatusLabel(order.status)}
                    </Typography>
                </Box>
                <Box mt={2}>

                
                <Typography variant="h6" fontWeight="bold">
                    order Products
                </Typography>
                <TableContainer component={Paper}
                sx={{
                    mt:2,
                    boxShadow:2,
                    borderRadius:3,
                    overflow:"hidden",
                    width:"100%"
                }}
                >
                    <Table sx={{minWidth: isSmallScreen ? "300px": "400px"}}>
                        <TableHead>
                            <TableRow sx={{backgroundColor:"#f5f5f5"}}>
                                <TableCell align="center" sx={{fontWeight:"bold",
                                    fontSize:isSmallScreen? "0.9rem": "1rem"
                                }}>
                                    {t('item')}
                                </TableCell>
                                <TableCell align="center" sx={{fontWeight:"bold",
                                    fontSize:isSmallScreen? "0.9rem": "1rem"
                                }}>
                                    {t('quanity')}
                                </TableCell>
                                <TableCell align="center" sx={{fontWeight:"bold",
                                    fontSize:isSmallScreen? "0.9rem": "1rem"
                                }}>
                                    {t('price')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products?.map((product, index)=>(
                                <TableRow 
                                key={product.id}
                                sx={{
                                    backgroundColor: index %2 ===0 ? "#fafafa": "#fff",
                                }}
                                >
                                    <TableCell align="center" sx={{fontSize: "0.95rem"}}>
                                        {product.product_name}
                                    </TableCell>
                                    <TableCell align="center" sx={{fontSize: "0.95rem"}}>
                                        {product.order_quantity}
                                    </TableCell>
                                    <TableCell align="center" sx={{fontSize: "0.95rem", fontWeight:"bold"}}>
                                        {product.unit_price} 
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </TableContainer>
                </Box>
                <Box mt={2}>
                    <Typography variant="body1">
                        <strong>{t('total')}:</strong> 
                       <>
                       {order.total} {""}
                       </>
                    </Typography>
                    <Typography variant="body1" mt={2}>
                        <strong>{t('discount-amount')}:</strong> {order?.discount}
                    </Typography>
                
                </Box>
            </CardContent>

        </Card>
    )
}

export default OrderCard;